import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { DDNY_MODEL_SCHEMA } from '../../../constants/ddny';

import { isDdnyUser } from '../../../utils/auth';
import {
	ddnyTitle,
} from '../../../utils/ddny';
import { getUrlId } from '../../../utils/formatting';

import LoadingIcon from '../../common/icons/LoadingIcon';
import ProductMedia from './blocks/ProductMedia';
import ViewRelatedItems from './blocks/ViewRelatedItems';
import ViewSectionAttributeBlock from './blocks/ViewSectionAttributeBlock';
import ViewSectionDataBlock from './blocks/ViewSectionDataBlock';

import styles from './_styles/DdnyProductPage.module.scss';

import * as ddnyActionCreators from '../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class DdnyProductPage extends Component {

	constructor(props) {

		super(props);

		this.productId = getUrlId();

		this.state = {

			product: null,

			attributesPending: false,
			
			requestPending: false,
			requestError: null,

			apiVariantData: null,
			apiVariantDataPending: false,
		}
		
		this.controller = null;
	}

	componentDidMount() {
		this.fetchProduct();
		this.fetchAttributes();
	}

	componentDidUpdate() {
		if(this.productId !== getUrlId()) {
			this.productId = getUrlId();

			this.fetchProduct();
			this.fetchAttributes();
			window.scrollTo(0, 0);
		}
	}

	componentWillUnmount() {
		if(this.controller) {
			this.controller.abort();
		}
	}

	async fetchProduct() {
		
		if(this.controller) {
			this.controller.abort();
		}
		const controller = new AbortController();
		this.controller = controller;
	
		this.setState({
			apiVariantDataPending: true,
			requestPending: true,
			requestError: null,
		});

		try {
			const productData = await this.props.ddnyFetchProductSingle(this.productId, controller.signal);
			this.setState({ product: productData });

			this.setState({
				requestPending: false,
			});

			// if(productData.sku && productData.sku.length > 3) {

			// 	const apiData = await this.props.ddnyFetchProductChildData(productData.sku);

			// 	if(apiData?.Status === 'success' && apiData?.Data?.data?.length > 0) {
					
			// 		const variantData = apiData?.Data?.data[0].variants?.length > 0 ? apiData?.Data?.data[0].variants : null;
			// 		this.setState({
			// 			apiVariantData: variantData,
			// 		});
			// 	}
			// }

		} catch(err) {
			console.error(err);
			this.setState({ requestError: 'Error fetching product' });
		} finally {
			this.setState({
				apiVariantDataPending: false,
				requestPending: false,
			});
		}
	}

	async fetchAttributes() {
		if(this.props.ddny.attributes === null) {
			try {
				this.setState({ attributesPending: true });
				await this.props.ddnyFetchAttributes();
			} catch(err) {
				console.error(err);
			} finally {
				this.setState({ attributesPending: false });
			}
		}
	}
	
	render() {
		return <div className={styles.DdnyProductPage}>
			<div className={styles.pageWrapper}>
				{this.state.requestPending 
					?	<div className={styles.loading}>
							<div className={styles.iconWrapper}>
								<LoadingIcon />
							</div>
							<div className={styles.loadingCopy}>Loading Jewelry</div>
						</div>
					:	<div className={styles.loaded}>
							<div className={styles.titleSection}>
								<div className={styles.nameWrapper}>
									<div className={styles.name}>{ddnyTitle(this.state.product)}</div>
									{isDdnyUser({ admin: true }) && (
										<Link 
											to={`/ddny/jewelry/edit/${this.state.product?.id || ''}`} 
											className={styles.editLink}>
											Edit
										</Link>
									)}
								</div>
								<div className={styles.sku}>{this.state.product?.sku}</div>
								<div className={styles.shareWrapper}>
									<a 
										href={'https://api.whatsapp.com/send?text=' + encodeURIComponent(`Take a look at this selection from DDNY: ${window.location.href}`)} 
										target='_blank'
										rel='noreferrer'>
										<div className={styles.shareIcon}>
											<img src='/img/singlediamond/share.svg' alt='Share' />
										</div>
										<div className={styles.shareLabel}>Share</div>
									</a>
								</div>
							</div>
							<div className={styles.mediaSection}>
								<ProductMedia
									product={this.state.product}
									readOnly={true}
									refresh={this.fetchProduct.bind(this)} />
							</div>
							{this.state.product?.related_items?.length > 0 && (
								<div className={`${styles.dataSection} ${styles.viewSection}`}>
									<div className={styles.title}>Related Items</div>
									<div className={styles.body}>
										<ViewRelatedItems 
											product={this.state.product} />
									</div>
								</div>
							)}
							
							<div className={`${styles.dataSection} ${styles.viewSection}`}>
								<div className={styles.title}>Product Data</div>
								<div className={styles.body}>
									<ViewSectionDataBlock 
										product={this.state.product}
										schema={DDNY_MODEL_SCHEMA['primary']}
										apiData={this.state.apiVariantData}
										apiDataPending={this.state.apiVariantDataPending} />
									<ViewSectionDataBlock 
										product={this.state.product}
										schema={DDNY_MODEL_SCHEMA['vendor']}
										apiData={this.state.apiVariantData}
										apiDataPending={this.state.apiVariantDataPending} />
									<ViewSectionDataBlock 
										product={this.state.product}
										schema={DDNY_MODEL_SCHEMA['web']}
										apiData={this.state.apiVariantData}
										apiDataPending={this.state.apiVariantDataPending} />
									<ViewSectionDataBlock 
										product={this.state.product}
										schema={DDNY_MODEL_SCHEMA['center']}
										apiData={this.state.apiVariantData}
										apiDataPending={this.state.apiVariantDataPending} />
									<ViewSectionDataBlock 
										product={this.state.product}
										schema={DDNY_MODEL_SCHEMA['noncenter']}
										apiData={this.state.apiVariantData}
										apiDataPending={this.state.apiVariantDataPending} />
								</div>
							</div>
							<div className={`${styles.attributesSection} ${styles.viewSection}`}>
								<div className={styles.title}>Product Attributes</div>
								<div className={styles.body}>
									{this.state.attributesPending 
										?	<div className={styles.bodyLoading}>
												<div className={styles.bodyIcon}>
													<LoadingIcon />
												</div>
											</div>
										:	<ViewSectionAttributeBlock
												product={this.state.product}
												attributes={this.props.ddny.attributes} />	
									}
								</div>
							</div>
							<div className={styles.actionsSection}>
								<Link to={'/ddny/gallery'}>
									<button type='button' className={`${styles.action} actionButton`}>
										Back to Results
									</button>
								</Link>
							</div>
						</div>
				}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {
		ddny: state.ddny,
	};
}

export default connect(mapStateToProps, allActionCreators)(DdnyProductPage);